import homeOnlineLearning from "../../../assets/images/home_online_learning.svg";
import homeSpeakingEnglish from "../../../assets/images/home_speaking_english.svg";
import homePracticalAndQuiz from "../../../assets/images/home_practical_and_quiz.svg";
import homeLearningMaterial from "../../../assets/images/home_learning_material.svg";
import homeGuidance from "../../../assets/images/home_guidance.svg";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
const ContentBox = ({ icon, title, description, className }) => {
  const formattedDescription = description.split('\n').map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));
  return (
    <div className={`flex flex-col items-start justify-end rounded-[30px] ${className}`}>
      <img src={icon} alt={title} className="w-[140px] h-[140px] tablet:w-[160px] tablet:h-[160px]" />
      <div className="flex flex-col items-start justify-start gap-[8px] tablet:mt-[32px] mt-[20px]">
        <p className="text-primary tablet:text-headline-large text-title-medium font-semibold font-inter">{title}</p>
        <p className="text-secondary-text tablet:text-headline-small text-title-small font-semibold font-inter break-keep whitespace-normal">{formattedDescription}</p>
      </div>
    </div>
  )
}

const DesktopContents = ({ inView }) => {
  return (
    <div className="max-w-[1480px] mx-auto w-full flex flex-col items-center">
      <div className="w-full flex flex-row mt-[80px] mb-[40px] gap-[40px]">
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft' : ''}`}>
          <ContentBox icon={homeOnlineLearning}
            title={"Online Learning"}
            description={"언제 어디서나 활용 수 있는\n다이나믹한 앱 기반 학습으로\n효과적인 예/복습 시스템"}
            className={"bg-[#2684FC]/[0.1] p-[36px]"} />
        </div>
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft delay-[1000ms]' : ''}`}>
          <ContentBox icon={homeSpeakingEnglish}
            title={"Speaking English"}
            description={"원어민 강사와 이중언어 강사진으로\n구성된 학습환경으로 다양한 대화로\n영어 표현 능력 강화"}
            className={"bg-primary-background border border-custom1/70 p-[36px]"} />
        </div>
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideRight delay-[2000ms]' : ''}`}>
          <ContentBox icon={homeGuidance}
            title={"Experienced tutors"}
            description={"학생들의 영어 학습 여정을\n함께 이끌어 나가는,\n경험 많고 실력있는 전문 강사진"}
            className={"bg-[#FFC93C]/[0.1] p-[36px]"} />
        </div>


      </div>
      <div className="w-full flex flex-row mb-[40px] gap-[40px]">
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft delay-[1500ms]' : ''}`}>
          <ContentBox icon={homeLearningMaterial}
            title={"Integrated Learning Program"}
            description={"듣기/ 어휘/ 읽기/ 쓰기/ 말하기/ 문법\n모든 영역을 고르게 훈련 할 수 있는 통합 교육 과정\n자체 교재 및 앱 계발을 통해 영역별 교과과정의 효과적 연계"}
            className={"bg-primary-background border border-custom1/70 p-[36px]"} />
        </div>
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideRight delay-[1000ms]' : ''}`}>
          <ContentBox icon={homePracticalAndQuiz}
            title={"Step-by-Step"}
            description={"알파벳 단계부터, 에세이를 쓰고 토론을 하는 마스터 단계까지.\n초등부터 수능 1등급 고등학교까지\n체계적 커리큘럼 설계"}
            className={"bg-alternate p-[36px]"} />
        </div>

      </div>

    </div>
  )
}
const TabletContents = ({ inView }) => {
  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-full flex flex-row mt-[80px] mb-[40px] gap-[40px]">
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft' : ''}`}>
          <ContentBox
            icon={homeOnlineLearning}
            title={"Online Learning"}
            description={"언제 어디서나,\n활용 할수 있는\n다이나믹한 앱 기반\n예/복습 시스템"}
            className={"bg-[#2684FC]/[0.1] p-[36px]"}
          />
        </div>
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft delay-[1000ms]' : ''}`}>
          <ContentBox
            icon={homeSpeakingEnglish}
            title={"Speaking English"}
            description={"원어민 강사와\n이중언어 강사진들의\n다양한 대화 및 아이디어\n 교환 프로그램"}
            className={"bg-primary-background border border-custom1/70 p-[36px]"}
          />
        </div>
      </div>
      <div className="w-full flex flex-row mb-[40px] gap-[40px]">
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideLeft delay-[1500ms]' : ''}`}>
          <ContentBox
            icon={homeLearningMaterial}
            title={"Integrated Program"}
            description={"듣기 / 읽기 / 쓰기 / 말하기\n통합 교육 과정.\n자체 교재 및 앱 개발을 통한\n영역별 교과과정 연계"}
            className={"bg-primary-background border border-custom1/70 p-[36px]"}
          />
        </div>
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideRight delay-[1000ms]' : ''}`}>
          <ContentBox
            icon={homePracticalAndQuiz}
            title={"Step-by-Step"}
            description={"초등 영어기초,\n중학교 내신,\n수능 1등급까지\n체계적 커리큘럼 설계"}
            className={"bg-alternate p-[36px]"}
          />
        </div>
      </div>
      <div className="w-full flex flex-row mb-[40px] gap-[40px]">
        <div className={`flex-[1] ${inView ? 'animate-fadeSlideRight delay-[2000ms]' : ''}`}>
          <ContentBox
            icon={homeGuidance}
            title={"Guidance from experienced tutors"}
            description={"학생들의 영어 학습 여정을 함께 이끌어 나가는,\n경험 많고 실력있는 전문 강사진"}
            className={"bg-[#FFC93C]/[0.1] p-[36px]"}
          />
        </div>
      </div>
    </div>
  )
}
const MobileContents = ({ inView }) => {
  return (
    <div className="w-full flex flex-col items-center gap-[10px] mt-[30px] mb-[30px]">
      <ContentBox
        icon={homeOnlineLearning}
        title={"Online Learning"}
        description={"언제 어디서나,활용 할 수 있는\n다이나믹한 앱 기반 예/복습 시스템"}
        className={"bg-[#2684FC]/[0.1] p-[20px] w-full"}
      />
      <ContentBox
        icon={homeSpeakingEnglish}
        title={"Speaking English"}
        description={"원어민 강사와 이중언어 강사진으로 구성된\n학습환경으로 다양한 대화로 영어 표현 능력 강화"}
        className={"bg-primary-background border border-custom1/70 p-[20px] w-full"}
      />
      <ContentBox
        icon={homeLearningMaterial}
        title={"Integrated Program"}
        description={"듣기 / 읽기 / 쓰기 / 말하기 통합 교육 과정.\n자체 교재 및 앱 개발을 통한 영역별 교과과정 연계"}
        className={"bg-primary-background border border-custom1/70 p-[20px] w-full"}
      />
      <ContentBox
        icon={homePracticalAndQuiz}
        title={"Step-by-Step"}
        description={"초등 영어기초, 중학교 내신, 수능 1등급까지\n체계적 커리큘럼 설계"}
        className={"bg-alternate p-[20px] w-full"}
      />
      <ContentBox
        icon={homeGuidance}
        title={"Guidance from experienced tutors"}
        description={"학생들의 영어 학습 여정을 함께 이끌어 나가는,\n경험 많고 실력있는 전문 강사진"}
        className={"bg-[#FFC93C]/[0.1] p-[20px] w-full"}
      />
    </div>
  )
}

const MobileMainCopy = () => {
  return <p className="w-full text-secondary-text tablet:text-headline-large text-title-large font-semibold font-inter pt-[15px]">
    아나톨레 어학원은, <br />
    쉽고 효과적으로 영어를 배울 수 있도록 설계된<br />
    맞춤형 영어 학습 전문 학원입니다.
  </p>
}

const TabletMainCopy = () => {
  return <p className="w-full text-secondary-text tablet:text-headline-large text-title-large font-semibold font-inter pt-[15px]">
    아나톨레 어학원은, <br />
    쉽고 효과적으로 영어를 배울 수 있도록 설계된<br />
    맞춤형 영어 학습 전문 학원입니다.
  </p>
}

const DesktopMainCopy = () => {
  return <p className="w-full text-secondary-text tablet:text-headline-large text-title-large font-semibold font-inter">
    아나톨레 어학원은, <br />
    쉽고 효과적으로 영어를 배울 수 있도록 설계된<br />
    맞춤형 영어 학습 전문 학원입니다.</p>
}


const DeskTopTitle = () => {
  return <div className="flex flex-col items-start">
    <p className="text-primary">What do you get at &nbsp;</p>
    <p className="text-secondary">Anatole Academy?</p>
  </div>
}

const MobileTitle = () => {
  return <div className="flex flex-col items-start">
    <p className="text-primary">What do you get at</p>
    <p className="text-secondary">Anatole Academy?</p>
  </div>
}

const TabletTitle = () => {
  return <p className="text-secondary"><span className="text-primary">What do you get at</span> Anatole Academy?</p>
}


export default function CoreValueSection() {
  const isDesktop = useMediaQuery('(min-width: 1480px)');
  const isTablet = useMediaQuery('(min-width: 888px)');
  const isMobile = useMediaQuery('(max-width: 887px)');
  const { ref: sectionRef, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  });

  return (
    <section ref={sectionRef} className="desktop:pb-[100px] pb-0 desktop:pt-[100px] pt-[50px] desktop:mb-[100px] mb-[50px] px-[16px] tablet:px-[35px]">
      <div className="max-w-[1480px] mx-auto flex flex-col items-center justify-center">
        <div className="w-full justify-start items-between gap-[80px] desktop:inline-flex inline-block">
          <div className={`flex-[1] w-full tablet:text-display-medium text-headline-medium font-semibold font-inter whitespace-normal break-keep  ${inView ? 'animate-fadeSlideLeft' : ''}`}>
            {(isMobile) ? <MobileTitle /> : isTablet && !isDesktop ? <TabletTitle /> : <DeskTopTitle />}
          </div>
          <div className={`flex-[1] flex flex-col justify-center ${inView ? 'animate-fadeSlideRight' : ''}`}>
            {(isMobile) ? <MobileMainCopy /> : isTablet && !isDesktop ? <TabletMainCopy /> : <DesktopMainCopy />}
          </div>
        </div>
      </div>
      {(isTablet && !isDesktop) ? <TabletContents inView={inView} /> : isMobile ? <MobileContents inView={inView} /> : <DesktopContents inView={inView} />}
    </section>
  );
} 